module.exports = __webpack_public_path__ + "static/media/sf-test-14.5b6917b9.mp3";